import React, {useState} from 'react';
import {useForm} from "react-hook-form";
import axios from "../../../../helpers/axios";
import {noDispHeader} from "../../../../helpers/errorTranslate";
import sayError from "../../../../helpers/sayError";
import LogoFlyArystan from "./logoFlyArystan";
import {Button, Form, Modal} from "react-bootstrap";
import BlockUi from "@availity/block-ui";

const UniversalModalParse = ({children, setter, setSecondaryInfo, type}) => {
  const neededInfo = variable[type]
  const [show, setShow]=useState(false)
  const [loading, setLoading]=useState(false)
  const formController = useForm()
  const { register,
    reset,
    handleSubmit,
    formState:{errors}} = formController
  const onSubmit = (data) =>{
    setLoading(true)
    const sendData = new FormData()
    console.log('file',data.file)
    sendData.append(neededInfo.fileName, data.file[0])
    axios.post(neededInfo.link, sendData,{headers: {...noDispHeader,
        'Content-Type':"application/x-www-form-urlencoded"}})
      .then(({data})=>{
        console.log('datafile', data)
        setter(data.converted)
        setSecondaryInfo(data)
        setShow(false)
      })
      .catch(sayError)
      .finally(()=>setLoading(false))
    console.log('data',data)
  }
  console.log('neededInfo', neededInfo, type)
  return (
    <div>
      <div onClick={()=>setShow(true)} style={{cursor:'pointer'}}>
        {children}
      </div>
      <Modal show={show} onHide={()=>setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{neededInfo.title}</Modal.Title>
        </Modal.Header>
        <BlockUi blocking={loading}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Modal.Body>
              <Form.Control
                type={"file"}
                {...register('file', { required: true })}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={()=>setShow(false)}>
                Закрыть
              </Button>
              <Button
                variant="primary"
                onClick={handleSubmit(onSubmit)}
              >
                Распарсить
              </Button>
            </Modal.Footer>
          </form>
        </BlockUi>
      </Modal>
    </div>
  );
};

export default UniversalModalParse;


const variable = {
  'flyArystan':{
    fileName: 'arystanPdf',
    link:'/api/air/parse/flyArystan',
    title:'Парс FlyArystan'
  },
  'vietJet': {
    fileName: 'vietjetPdf',
    link:'/api/air/parse/vietJet',
    title:'Парс Vietjet Air'
  }
}
